









import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Title extends Vue {
  @Prop({ type: String, required: true, default: '' }) readonly title!: string;

  @Prop({ type: String, required: true, default: '' }) readonly description!: string;
}
